export default '/src/assets/webgl/francesca_1/audios/outro.mp3'